export interface Component {
  id: string;
  name: string;
  type: string;
  cost: number;
  is_active: boolean;
  component_type?: string;
  calculation_type?: string;
  description?: string;
  behavior_type?: string; // NEW: 'base' or 'additive' for cascading pricing
}

export interface Port {
  id: string;
  name: string;
  country?: string;
}

export interface TransportType {
  id: string;
  name: string;
}

export interface ShipmentType {
  id: string;
  name: string;
}

export interface ContainerSize {
  id: string;
  name: string;
}

export interface Incoterm {
  id: string;
  name: string;
}

export interface PricingComponent {
  id: string;
  name: string;
  calculation_type: string;
  description: string;
  behavior_type?: string; // NEW: 'base' or 'additive' for cascading pricing
}

export interface PricingValue {
  id: string;
  value: number;
  unit: string | null;
  currency: string;
  included_products: number | null;
  extra_product_cost: number | null;
  pricing_component: PricingComponent;
}

export interface Rule {
  id: string;
  name: string;
  description?: string;
  is_active: boolean;
  valid_from: string | null;
  valid_to: string | null;
  transport_type?: {
    id: string;
    name: string;
  };
  origin_port?: {
    id: string;
    name: string;
  };
  destination_port?: {
    id: string;
    name: string;
  };
  shipment_type?: {
    id: string;
    name: string;
  };
  incoterm?: {
    id: string;
    name: string;
  };
  container_size?: {
    id: string;
    name: string;
  };
}

export interface MatchReasons {
  transportType?: string;
  originPort?: string;
  destinationPort?: string;
  shipmentType?: string;
  incoterm?: string;
}

export interface TariffBracket {
  id: string;
  from: number | null;
  to: number | null;
  transport_type?: {
    id: string;
    name: string;
  };
}

export interface SimulationResult {
  rule: Rule;
  components: Component[];
  totalAmount: number;
  selectedTariff?: {
    id: string;
    transport_type: string;
    origin_port: string;
    destination_port: string;
    price: number;
    bookings_type: string | null;
    calculatedCost?: number;
    transport_type_name?: string;
    origin_port_name?: string;
    destination_port_name?: string;
    shipment_type_name?: string;
    volumetricWeight?: number;
    actualWeight?: number;
    chargeableWeight?: number;
    calculationType?: "volumetric" | "actual";
    volume?: number;
    tariff_bracket?: TariffBracket;
  };
  matchReasons?: MatchReasons;
}

// Analytics event names
export const PRICING_EVENTS = {
  VIEW_PAGE: "pricing_admin_viewed",
  ADD_COMPONENT: "pricing_component_added",
  UPDATE_COMPONENT: "pricing_component_updated",
  DELETE_COMPONENT: "pricing_component_deleted",
  ADD_RULE: "pricing_rule_added",
  UPDATE_RULE: "pricing_rule_updated",
  DELETE_RULE: "pricing_rule_deleted",
  ADD_VALUE: "pricing_value_added",
  UPDATE_VALUE: "pricing_value_updated",
  DELETE_VALUE: "pricing_value_deleted",
}; 